import { hasCapability, type User } from "../base";

export const hubspot = {
  upsert: (user: User) => hasCapability(user, "hubspot.upsert"),
  read: (user: User) => hasCapability(user, "hubspot.read"),
};
